
// Tabs

export const init = () => {

    // ページトップボタンの表示
    jQuery(function($) {
        
        if ( $('#pageup').length > 0 ) {
            var topBtn = $('#pageup');
            topBtn.css("display", "none");
            //スクロールが100に達したらボタン表示
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    topBtn.fadeIn();
                } else {
                    topBtn.fadeOut();
                }
            });
            //スクロールしてトップ
            topBtn.click(function () {
                $('body,html').animate({
                    scrollTop: 0
                }, 500);
                return false;
            });
        }
    });
};
export default init;

